export default {
  getCampaign: (state) => {
    return state.campaign;
  },

  getHasExpiration: (state) => {
    return state.hasExpiration;
  },

  getValidFrom: (state) => {
    return state.valid_from;
  },

  getValidUntil: (state) => {
    return state.valid_until;
  },

  getValidate: (state) => {
    return state.validate;
  },

  getPromotionsCampaigns: (state) => {
    return state.promotionsCampaigns;
  },

  getRegionsSelected: (state) => {
    return state.regionsSelected;
  },

  getAllPlacesSelected: (state) => {
    return state.allPlacesSelected;
  },

  getChildSelected: (state) => {
    return state.childSelected;
  },

  getPostersSelected: (state) => {
    return state.postersSelected;
  },

  getPosterId: (state) => {
    return state.posterId;
  },

  getStatesSelected: (state) => {
    return state.statesSelected.sort();
  },
}


// WEBPACK FOOTER //
// ./resources/assets/js/components/store/release-posters/getters.js